import React, { useRef, useState } from 'react';
import cn from '../../utils/cn';

const OTPInput = ({ onChange, disabled = false }) => {
  const [values, setValues] = useState(Array(6).fill(''));
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, '').slice(-1);
    const next = [...values];
    next[index] = val;
    setValues(next);
    onChange(next.join(''));
    if (val && index < 5) inputs.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !values[index] && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    const next = Array(6).fill('');
    pasted.split('').forEach((ch, i) => { next[i] = ch; });
    setValues(next);
    onChange(next.join(''));
    inputs.current[Math.min(pasted.length, 5)]?.focus();
  };

  return (
    <div className="flex gap-3 justify-center" onPaste={handlePaste}>
      {values.map((val, i) => (
        <input
          key={i}
          ref={(el) => (inputs.current[i] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={val}
          disabled={disabled}
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          aria-label={`OTP digit ${i + 1}`}
          className={cn(
            'w-12 h-14 text-center text-xl font-bold rounded-xl border-2 bg-white',
            'transition-all duration-150 outline-none',
            'focus:border-primary-500 focus:ring-4 focus:ring-primary-100',
            val ? 'border-primary-400 text-primary-700' : 'border-gray-200 text-gray-900',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
        />
      ))}
    </div>
  );
};

export default OTPInput;
